/**
 * Toggle UI that still uses static/mock data (src/data/* or local-only state).
 * Set a flag to `true` when the section is wired to a real API.
 *
 * Hidden sections stay in the codebase — they are not rendered until enabled.
 */

export const UI_SECTIONS = {
  /** Agentic Workflows home (src/data/workflowsData.js) */
  workflowsMockHome: false,

  profileSettings: {
    /** Settings → API Keys — real API (GET/POST /api/v1/api-keys) */
    apiKeys: true,
    /** Legacy profile webhooks list — not webhook-registry API */
    webhooks: false,
    notifications: false,
    security: false,
    dataRetention: false,
    /** useTeamMembers hook — real API */
    teamMembers: true
  },

  companySettings: {
    /** Roles list from src/data/companyData.js */
    teamRolesPermissions: true,
    /** Billing tab from src/data/companyData.js */
    billingUsage: false
  },

  sidebar: {
    /** Nav link to the Workflows home (real API-backed list) */
    workflowsNav: true
  }
};

/** @param {boolean | undefined} flag */
export function showSection(flag) {
  return flag !== false;
}
